module.exports = __webpack_public_path__ + "static/media/Simran.84501fa1.jpg";